const DATABASE_NAME = 'talkvia-appearance';
const DATABASE_VERSION = 1;
const STORE_NAME = 'local-assets';
const WALLPAPER_KEY = 'conversation-wallpaper';

let databasePromise;

const openDatabase = () => {
  if (!globalThis.indexedDB) {
    return Promise.reject(new Error('IndexedDB is not available'));
  }

  if (!databasePromise) {
    databasePromise = new Promise((resolve, reject) => {
      const request = globalThis.indexedDB.open(
        DATABASE_NAME,
        DATABASE_VERSION
      );

      request.onupgradeneeded = () => {
        if (!request.result.objectStoreNames.contains(STORE_NAME)) {
          request.result.createObjectStore(STORE_NAME);
        }
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }

  return databasePromise;
};

const waitForTransaction = transaction =>
  new Promise((resolve, reject) => {
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error);
    transaction.onabort = () => reject(transaction.error);
  });

export const saveLocalConversationWallpaper = async file => {
  const database = await openDatabase();
  const transaction = database.transaction(STORE_NAME, 'readwrite');

  transaction.objectStore(STORE_NAME).put(
    {
      blob: file,
      name: file.name,
      size: file.size,
      type: file.type,
      updatedAt: Date.now(),
    },
    WALLPAPER_KEY
  );

  await waitForTransaction(transaction);
};

export const getLocalConversationWallpaper = async () => {
  const database = await openDatabase();
  const transaction = database.transaction(STORE_NAME, 'readonly');
  const request = transaction.objectStore(STORE_NAME).get(WALLPAPER_KEY);

  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result || null);
    request.onerror = () => reject(request.error);
  });
};

export const removeLocalConversationWallpaper = async () => {
  const database = await openDatabase();
  const transaction = database.transaction(STORE_NAME, 'readwrite');

  transaction.objectStore(STORE_NAME).delete(WALLPAPER_KEY);
  await waitForTransaction(transaction);
};
